// extracted by mini-css-extract-plugin
export default {"mobile":"sitefooter_mobile__+QNX-","small":"sitefooter_small__xG1sF","custom_list":"sitefooter_custom_list__xqDrL"};